import React from "react";
import Keyboard from "./Keyboard";
import Modal from "./Modal";
import {
  compare,
  copyToClipboard,
  getAvailableKeys,
  getLongest,
  isValidKaomoji,
  makeTrie,
  parseCharset,
  stateToColor
} from "./utils";

export const NOOP = () => {};

function scrollToBottom() {
  var objDiv = document.getElementById("display");
  objDiv.scrollTop = objDiv.scrollHeight;
}

export default class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      guesses: [],
      guess: [],
      limit: getLongest(props.wordbank),
      keymap: parseCharset(this.props.wordbank),
      resultShow: false,
      bankShow: false,
      infoShow: false,
      isWin: false
    };
    this.wordbankMap = this.props.wordbank.reduce((acc, w) => {
      acc[w] = w;
      return acc;
    }, {});
    this.wordTrie = makeTrie(this.props.wordbank);
    this.onKeypress = this.onKeypress.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onToggleResult = this.onToggleResult.bind(this);
    this.onToggleBank = this.onToggleBank.bind(this);
    this.onToggleInfo = this.onToggleInfo.bind(this);
    this.copyResultToClipboard = this.copyResultToClipboard.bind(this);
    this.copyShareLinkToClipboard = this.copyShareLinkToClipboard.bind(this);
  }

  onKeypress(key) {
    if (this.state.guess.length >= this.state.limit) {
      return;
    }
    this.setState({
      guess: this.state.guess.concat([key])
    });
  }

  onDelete() {
    this.setState({
      guess: this.state.guess.slice(0, this.state.guess.length - 1)
    });
  }

  onEnter() {
    const guess = this.state.guess;
    if (guess.length < 1) {
      return;
    }
    if (!this.wordbankMap[guess.join("")]) {
      return alert("Not a valid Kaomoji!");
    }
    const result = compare(this.props.solution, guess.join(""));
    const isWin =
      result.every((r) => r.match === 2) &&
      result.length === this.props.solution.length;
    this.setState(
      {
        guesses: this.state.guesses.concat([result]),
        guess: [],
        isWin,
        keymap: this.state.keymap.map((k) => {
          let state = k.state;
          result.forEach((r) => {
            if (r.char === k.key) {
              state = Math.max(k.state, r.match);
            }
          });
          if (state !== k.state) {
            return { key: k.key, state };
          } else {
            return k;
          }
        }),
        resultShow: isWin ? true : false
      },
      () => scrollToBottom()
    );
    console.log(result);
  }

  onToggleResult(show) {
    this.setState({
      resultShow: show || false
    });
  }

  onToggleBank(show) {
    this.setState({
      bankShow: show || false
    });
  }

  onToggleInfo(show) {
    this.setState({
      infoShow: show || false
    });
  }

  copyResultToClipboard() {
    const header =
      "Kaomojidle " +
      this.props.seed +
      " " +
      this.state.guesses.length +
      "/∞\n\n";
    const guesses = this.state.guesses
      .map((result) => {
        return result
          .map((r) => {
            switch (r.match) {
              case 2:
                return "🟩";
              case 1:
                return "🟨";
              default:
                return "⬜️";
            }
          })
          .join("");
      })
      .join("\n");
    console.log(header + guesses);
    copyToClipboard(header + guesses);
    alert("Copied result to clipboard!");
  }

  copyShareLinkToClipboard() {
    const base =
      document.location.protocol +
      "//" +
      document.location.host +
      document.location.pathname;
    const shareLink = base + "?" + this.props.seed;
    copyToClipboard(shareLink);
    alert("Copied puzzle link to clipboard!");
  }

  render() {
    const nextKeys = getAvailableKeys(this.wordTrie, this.state.guess);
    const isValidKaomojiB = isValidKaomoji(this.wordTrie, this.state.guess);
    return (
      <div className="flex flex-col h-full justify-between">
        <Modal
          show={this.state.infoShow}
          onClose={() => this.onToggleInfo(false)}
        >
          <h1 className="font-bold mb-4">Info</h1>
          <div>
            <p className="mb-3">
              You get an unlimited number of guesses to guess the kaomoji.
            </p>
            <p className="mb-3">
              Each guess must be a valid Kaomoji (see the Kaomoji list for
              reference).
            </p>
            <p className="mb-3">Click the "Enter" button to submit.</p>
            <p className="mb-4">
              After each guess, the color of the tiles will change to show how
              close your guess was to the word.
            </p>
            <h2 className="font-semibold mb-3">Examples</h2>
            <div>
              <span className="bg-green-500">(</span>
              <span className="bg-slate-200">＃</span>
              <span className="bg-slate-200">`</span>
              <span className="bg-slate-200">Д</span>
              <span className="bg-slate-200">´</span>
              <span className="bg-slate-200">)</span>
              <div className="mb-3">
                The character "(" is in the right spot.
              </div>
              <span className="bg-slate-200">(</span>
              <span className="bg-yellow-500">＃</span>
              <span className="bg-slate-200">`</span>
              <span className="bg-slate-200">Д</span>
              <span className="bg-slate-200">´</span>
              <span className="bg-slate-200">)</span>
              <div className="mb-3">
                The character "#" is in the kaomoji but in the wrong spot.
              </div>

              <span className="bg-slate-200">(</span>
              <span className="bg-slate-200">＃</span>
              <span className="bg-slate-400">`</span>
              <span className="bg-slate-200">Д</span>
              <span className="bg-slate-200">´</span>
              <span className="bg-slate-200">)</span>
              <div className="mb-3">
                The character "`" is not in the kaomoji.
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          show={this.state.resultShow}
          onClose={() => this.onToggleResult(false)}
        >
          <div className="font-bold text-lg mb-2">
            You Won in {this.state.guesses.length} Guess
            {this.state.guesses.length === 1 ? "" : "es"}!
          </div>
          <div
            className="p-2 underline border-round cursor-pointer bg-slate-200"
            onClick={this.copyResultToClipboard}
          >
            Copy Result to Clipboard
          </div>
        </Modal>
        <Modal
          show={this.state.bankShow}
          onClose={() => this.onToggleBank(false)}
        >
          <div className="flex flex-col">
            <h1 className="font-bold mb-6">Kaomoji List</h1>
            <div className="relative mb-4">
              {this.props.wordbank.map((kaomoji, i) => {
                return <div key={kaomoji}>{kaomoji}</div>;
              })}
            </div>
          </div>
        </Modal>
        <div className="bg-slate-200 w-full flex h-9 grow-0 shrink-0 overflow-x-scroll">
          <div
            className="m-2 inline-block whitespace-nowrap cursor-pointer font-semibold text-sm underline"
            onClick={() => this.onToggleInfo(true)}
          >
            Info
          </div>
          <div
            className="m-2 inline-block whitespace-nowrap cursor-pointer font-semibold text-sm underline"
            onClick={() => this.onToggleBank(true)}
          >
            Kaomoji List
          </div>

          <div
            className="m-2 inline-block whitespace-nowrap cursor-pointer font-semibold text-sm underline"
            onClick={this.copyShareLinkToClipboard}
          >
            Share ({this.props.seed})
          </div>
          <div
            className="m-2 inline-block whitespace-nowrap cursor-pointer font-semibold text-sm underline"
            onClick={() =>
              (document.location.href =
                document.location.protocol +
                "//" +
                document.location.host +
                document.location.pathname)
            }
          >
            New Puzzle
          </div>
          {this.state.isWin && (
            <div
              className="m-2 inline-block whitespace-nowrap cursor-pointer font-semibold text-sm underline"
              onClick={() => this.onToggleResult(true)}
            >
              Show Result
            </div>
          )}
        </div>
        <div className="overflow-y-scroll mb-auto p-4" id="display">
          <div className="w-full text-center text-xl">
            {this.state.guesses.map((result, i) => {
              return (
                <div className="" key={i}>
                  {result.map(({ char, match }, i) => {
                    let color = stateToColor(match);
                    return (
                      <span key={i} className={color}>
                        {char}
                      </span>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className=" w-full h-6 mb-auto text-center text-xl">
            {this.state.guess.map((g, i) => (
              <span key={i}>{g}</span>
            ))}

            {!this.state.isWin && (
              <span className="relative">
                <span className="absolute border-b-4 border-purple-400 w-3 h-7">
                  　
                </span>
              </span>
            )}
          </div>
        </div>
        <Keyboard
          onKeypress={this.state.isWin ? NOOP : this.onKeypress}
          onDelete={
            this.state.isWin || this.state.guess.length < 1
              ? NOOP
              : this.onDelete
          }
          onEnter={this.state.isWin || !isValidKaomojiB ? NOOP : this.onEnter}
          keymap={this.state.keymap}
          enabledKeys={nextKeys}
        />
      </div>
    );
  }
}
